module.exports = __webpack_public_path__ + "klue-logo-black-aae1691250a897df7ff29ae78a26db17.svg";